<template>
<a v-if="href"
   :href="href"
   :tabindex="show ? '0' : '-1'"
   @keydown="handleKeydown">
  {{ text }}
</a>
</template>

<script>
export default {
  name: "DropdownTitle",

  computed: {
    text() {
      if (!this.$parent.dropdownTitle) {
        return null;
      }

      return this.$parent.dropdownTitle.text;
    },

    href() {
      if (!this.$parent.dropdownTitle) {
        return null;
      }

      return this.$parent.dropdownTitle.href;
    },

    show() {
      return this.$parent.show;
    }
  },

  methods: {
    handleKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.$parent.close();
      }
    }
  }
};
</script>
